'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropdown = require('dropdown');

var _reactIframe = require('react-iframe');

var _reactIframe2 = _interopRequireDefault(_reactIframe);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _constants = require('../utils/constants');

var _reactColor = require('react-color');

var _wfWidgetItem = require('./wf-widget-item');

var _wfWidgetItem2 = _interopRequireDefault(_wfWidgetItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(
  'span',
  null,
  'Outer wrapper frame'
);

var _ref2 = _react2.default.createElement(
  'p',
  null,
  'Code:'
);

var _ref3 = _react2.default.createElement(
  'p',
  null,
  'Preview:'
);

var _ref4 = _react2.default.createElement(
  'p',
  null,
  'No preview to display (no profile or layout type selected)'
);

var WfHorizontalWidget = function (_WfWidgetItem) {
  (0, _inherits3.default)(WfHorizontalWidget, _WfWidgetItem);

  function WfHorizontalWidget() {
    (0, _classCallCheck3.default)(this, WfHorizontalWidget);
    return (0, _possibleConstructorReturn3.default)(this, _WfWidgetItem.apply(this, arguments));
  }

  WfHorizontalWidget.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;

    var selectedLayout = props.layoutsList.indexOf(props.page.selectedLayout) !== -1 ? props.page.selectedLayout : props.layoutsList[0];

    var link = props.page.hrefLink !== undefined ? props.page.hrefLink : '';
    var selectedBackground = props.page.selectedBackground || { id: 'white', name: 'White' };

    var searchQuery = '/' + props.uri + (0, _constants.queryStringFromObject)({
      profileId: props.page.selectedProfile && props.page.selectedProfile.uriId || '',
      profileType: props.page.selectedProfileType && props.page.selectedProfileType.id || '',
      layoutType: selectedLayout && selectedLayout.id || '',
      link: link,
      responsiveId: this.state.id,
      customizations: (0, _extends3.default)({}, props.page.customizations, {
        bodyStyle: { 'backgroundColor': selectedBackground.id }
      }),
      bodyStyle: { 'backgroundColor': selectedBackground.id },
      profilesIds: props.page.selectedMultipleProfiles && props.page.selectedMultipleProfiles.map(function (item) {
        return item.uriId;
      }) || []
    });

    var isProfileTypeSelected = props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE);

    var profileItems = props.page.selectedProfileType && props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE && props.page.fetchedSpecialists || props.page.selectedProfileType && props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && props.page.fetchedPractices || [];

    return _react2.default.createElement(
      'div',
      {
        className: _style2.default.exampleSection
      },
      _react2.default.createElement(
        'h2',
        null,
        props.title
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.options },
        _react2.default.createElement(
          'div',
          { className: _style2.default["options-item"] },
          _react2.default.createElement(
            'span',
            { className: _style2.default.selectDescription },
            'Profile Type:'
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.dropdownContainer },
            _react2.default.createElement(_dropdown.Dropdown, {
              className: _style2.default.profileDropdown,
              items: _constants.PROFILE_TYPES,
              readonly: true,
              selectedItem: props.page.selectedProfileType,
              onItemSelected: props.pageActions.onProfileTypeSelected,
              placeholder: 'Select a profile type',
              ItemRenderer: function ItemRenderer(rendererProps) {
                var item = rendererProps.item,
                    nameTransform = rendererProps.nameTransform;

                return _react2.default.createElement(
                  'div',
                  { className: '' + _style2.default.dropdownItem },
                  item.iconUri ? _react2.default.createElement('img', { src: item.iconUri, alt: 'icon' }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                  _react2.default.createElement(
                    'span',
                    null,
                    nameTransform(item)
                  )
                );
              } })
          ),
          isProfileTypeSelected && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: _style2.default.selectDescription },
              'Profile:'
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.dropdownContainer },
              _react2.default.createElement(_dropdown.Dropdown, {
                className: _style2.default.profileDropdown,
                items: profileItems,
                readonly: !(props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE)),
                selectedItem: props.page.selectedProfile,
                onItemSelected: props.pageActions.onProfileSelected,
                onTextChanged: function onTextChanged(filter) {
                  return props.pageActions.getDirectoryAutocomplete(filter, props.page.selectedProfileType && props.page.selectedProfileType.id);
                },
                placeholder: 'Type a name',
                ItemRenderer: function ItemRenderer(rendererProps) {
                  var item = rendererProps.item,
                      nameTransform = rendererProps.nameTransform;

                  return _react2.default.createElement(
                    'div',
                    { className: '' + _style2.default.dropdownItem },
                    item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                    _react2.default.createElement(
                      'span',
                      null,
                      nameTransform(item)
                    )
                  );
                }
              })
            )
          ),
          isProfileTypeSelected && props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: _style2.default.selectDescription },
              'Additional profiles:'
            ),
            _react2.default.createElement(
              'div',
              { className: _style2.default.dropdownContainer },
              _react2.default.createElement(_dropdown.Dropdown, {
                className: _style2.default.profileDropdown,
                items: profileItems,
                readonly: !(props.page.selectedProfileType && (props.page.selectedProfileType.id === _constants.SPECIALIST_PROFILE_TYPE || props.page.selectedProfileType.id === _constants.PRACTICE_PROFILE_TYPE)),
                selectedItem: props.pageActions.onMultipleProfileSelected,
                onItemSelected: props.pageActions.onMultipleProfileSelected,
                onTextChanged: function onTextChanged(filter) {
                  return props.pageActions.getDirectoryAutocomplete(filter, props.page.selectedProfileType && props.page.selectedProfileType.id);
                },
                placeholder: 'Type a name',
                clearOnSelect: true,
                ItemRenderer: function ItemRenderer(rendererProps) {
                  var item = rendererProps.item,
                      nameTransform = rendererProps.nameTransform;

                  return _react2.default.createElement(
                    'div',
                    { className: '' + _style2.default.dropdownItem },
                    item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                    _react2.default.createElement(
                      'span',
                      null,
                      nameTransform(item)
                    )
                  );
                }
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: _style2.default.selectDescription },
                'Profiles:'
              ),
              props.page.selectedMultipleProfiles.map(function (profile) {
                return _react2.default.createElement(
                  'div',
                  null,
                  profile.name,
                  _react2.default.createElement(
                    'button',
                    {
                      onClick: function onClick() {
                        props.pageActions.onMultipleProfileRemoved(profile.id);
                      },
                      className: _style2.default.removeProfileButton
                    },
                    'Remove'
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default["options-item"] },
          _react2.default.createElement(
            'span',
            { className: _style2.default.selectDescription },
            'Layout Type:'
          ),
          _react2.default.createElement(
            'div',
            { className: _style2.default.dropdownContainer },
            _react2.default.createElement(_dropdown.Dropdown, {
              className: _style2.default.profileDropdown,
              items: props.layoutsList,
              readonly: true,
              selectedItem: selectedLayout,
              onItemSelected: props.pageActions.onLayoutSelected,
              placeholder: 'Select a layout',
              ItemRenderer: function ItemRenderer(rendererProps) {
                var item = rendererProps.item,
                    nameTransform = rendererProps.nameTransform;

                return _react2.default.createElement(
                  'div',
                  { className: '' + _style2.default.dropdownItem },
                  item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                  _react2.default.createElement(
                    'span',
                    null,
                    nameTransform(item)
                  )
                );
              } })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default["options-item"] },
          _react2.default.createElement(
            'div',
            { className: _style2.default.dropdownContainer },
            _react2.default.createElement(
              'span',
              { className: _style2.default.selectDescription },
              'Background'
            ),
            _react2.default.createElement(_dropdown.Dropdown, {
              className: _style2.default.profileDropdown,
              items: [{ id: 'white', name: 'White' }, { id: 'transparent', name: 'Transparent' }],
              readonly: true,
              selectedItem: selectedBackground,
              onItemSelected: props.pageActions.onBackgroundSelected,
              placeholder: 'Select a layout',
              ItemRenderer: function ItemRenderer(rendererProps) {
                var item = rendererProps.item,
                    nameTransform = rendererProps.nameTransform;

                return _react2.default.createElement(
                  'div',
                  { className: '' + _style2.default.dropdownItem },
                  item.iconUri ? _react2.default.createElement('img', { src: item.iconUri }) : _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                  _react2.default.createElement(
                    'span',
                    null,
                    nameTransform(item)
                  )
                );
              } })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default["options-item"] },
          _react2.default.createElement(
            'div',
            { className: _style2.default.dropdownContainer },
            _react2.default.createElement(
              'span',
              { className: _style2.default.selectDescription },
              'Full link to page: '
            ),
            _react2.default.createElement('input', {
              className: _style2.default.dropdownItem,
              value: props.page.hrefLink !== undefined ? props.page.hrefLink : '',
              placeholder: 'https://example.com/contacts',
              onChange: function onChange(event) {
                return props.pageActions.onHrefLinkChanged(event.target.value);
              },
              style: { width: '250px' }
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default["options-item"] },
          _react2.default.createElement(
            'div',
            { className: _style2.default.dropdownContainer },
            _react2.default.createElement(
              'label',
              null,
              'Review Item Frame',
              _react2.default.createElement('input', {
                className: _style2.default.checkbox,
                type: 'checkbox',
                name: 'reviewItemFrame',
                checked: props.page.customizations.reviewItemFrame,
                onClick: function onClick() {
                  _this2.toggleCustomizationProp("reviewItemFrame");
                }
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default["options-item"] },
          _react2.default.createElement(
            'div',
            { className: _style2.default.dropdownContainer },
            _react2.default.createElement(
              'span',
              { onClick: this.toggleReviewItemColorPicker },
              'Review Item Background'
            ),
            _react2.default.createElement(
              'button',
              {
                className: _style2.default["color-picker-button"],
                onClick: this.toggleReviewItemColorPicker
              },
              _react2.default.createElement(
                'div',
                { style: {
                    backgroundColor: props.page.customizations.reviewItemBackground,
                    color: props.page.customizations.reviewItemBackground || "black"
                  } },
                'Select Background'
              )
            ),
            this.props.page.displayReviewItemColorPicker ? _react2.default.createElement(
              'div',
              { className: _style2.default.popover },
              _react2.default.createElement('div', {
                className: _style2.default.cover,
                onClick: this.toggleReviewItemColorPicker
              }),
              _react2.default.createElement(_reactColor.ChromePicker, {
                color: props.page.customizations.reviewItemBackground,
                onChange: function onChange(value) {
                  return _this2.setCustomizationProp("reviewItemBackground", value.hex);
                },
                disableAlpha: true
              })
            ) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _style2.default["options-item"] },
          _react2.default.createElement(
            'div',
            { className: _style2.default.dropdownContainer },
            _react2.default.createElement(
              'label',
              { className: _style2.default['checkbox-label'] },
              _ref,
              _react2.default.createElement('input', {
                type: 'checkbox',
                name: 'wrapperFrame',
                checked: props.page.customizations.wrapperFrame,
                onClick: function onClick() {
                  _this2.toggleCustomizationProp("wrapperFrame");
                }
              })
            )
          )
        )
      ),
      props.page.selectedProfileType && props.page.selectedProfile && _react2.default.createElement(
        'div',
        { className: _style2.default.codeSnippet },
        _ref2,
        _react2.default.createElement(
          'pre',
          null,
          _react2.default.createElement(
            'code',
            null,
            '<iframe frameborder="0" src="',
            'https://widgets.doctify.co.uk' + searchQuery,
            '" id="',
            this.state.id,
            '" class="wf-responsive-widget" style="position:relative;display:block;border:none;overflow:hidden;width:100%;max-width:',
            selectedLayout.width,
            '" width="100%" display="block"></iframe>',
            '\n' + this.state.resizeScriptEl.outerHTML
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.practiceReviewsIframe },
        _ref3,
        props.page.selectedProfileType && props.page.selectedProfile && this.attachResizeScript() && _react2.default.createElement(_reactIframe2.default, {
          id: this.state.id,
          className: 'wf-responsive-widget',
          url: '' + this.state.baseUrl + searchQuery,
          display: 'block',
          width: '100%',
          position: 'relative',
          styles: { 'overflow': 'hidden', width: '100%', maxWidth: selectedLayout.width }
        }) || _react2.default.createElement(
          'div',
          { className: [_style2.default.noPreview].join(' ') },
          _ref4
        )
      )
    );
  };

  return WfHorizontalWidget;
}(_wfWidgetItem2.default);

exports.default = WfHorizontalWidget;
;